
<router-outlet></router-outlet>
<p-toast position="top-right"></p-toast>
<div class="app-loader" *ngIf="showLoader || showLoader1">
    <mat-spinner [diameter]="50" [strokeWidth]="8"></mat-spinner>
</div>